import { render, staticRenderFns } from "./Modal-Bills.vue?vue&type=template&id=6f95fbcc&scoped=true&"
import script from "./Modal-Bills.vue?vue&type=script&lang=js&"
export * from "./Modal-Bills.vue?vue&type=script&lang=js&"
import style0 from "./Modal-Bills.vue?vue&type=style&index=0&id=6f95fbcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f95fbcc",
  null
  
)

export default component.exports